import { http } from 'utils'
import { SET_ITEMS, ADD_ITEMS } from 'vx/mutations'
import { concat } from 'lodash'

export default {
  namespaced: true,

  state: {
    firefighters: []
  },

  actions: {
    async getFirefighters ({ commit }, { params = {} } = {}) {
      const response = await http.get('lists/firefighters')

      commit(ADD_ITEMS, response.data.data)

      return response
    }
  },

  mutations: {
    [SET_ITEMS] (state, items) {
      state.firefighters = items
    },

    [ADD_ITEMS] (state, items) {
      state.firefighters = concat(state.firefighters, items)
    }
  }
}
